/* ============================================================
   Zenoura native cart bridge — Phase 5
   Model:
   1) QUANTITY = variant composition, no Shopify discount.
      unitQty -> packQty = floor(u/2), singleQty = u%2. The cart holds the real
      pack (2-stk) + single (1-stk) price-SKUs, so checkout is correct natively
      and lines never split from a discount allocation.
   2) CROSS-PRODUCT = a single native discount code, chosen by the JS router and
      applied via /cart/update.js ({discount:"CODE"} / {discount:""} to clear).
      Rules are mutually exclusive so one code per cart is always enough.
   3) DISPLAY = server-grouped rows (cart.ajax view): one line per product,
      Shopify-computed price. No JS-computed prices.

   Requires the Qikify Slide Cart app embed to be OFF.
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Cross-product discount codes — confirmed active in Shopify Admin
     (Benji, 2026-07-06). If a code is later renamed/deactivated in Admin,
     applying it is a harmless no-op and the router only console-logs — the
     storefront keeps promising the discount, so verify Admin after changes. */
  var CODE_PRO_PULSE = 'ZN-PP200-4KX7'; // 200 kr off Zen Pulse when Zen Pro is in cart
  var CODE_RUTINE    = 'ZN-RUT15-9F3A2'; // 15% off order when 2+ distinct products

  // Open Motion's drawer via its own opener, but cancel the opener anchor's
  // href navigation so a programmatic open never lands on /cart.
  function openDrawer() {
    var opener = document.querySelector('.js-drawer-open-cart');
    if (!opener) return false;
    var stop = function (e) { e.preventDefault(); };
    opener.addEventListener('click', stop);
    opener.click();
    opener.removeEventListener('click', stop);
    return true;
  }

  function setBubble(count) {
    var host = document.querySelector('.cart-link');
    var bubble = document.querySelector('.cart-link__bubble');
    if (count > 0) {
      if (!bubble && host) {
        bubble = document.createElement('span');
        bubble.className = 'cart-link__bubble';
        host.appendChild(bubble);
      }
      if (bubble) bubble.classList.add('cart-link__bubble--visible');
    } else if (bubble) {
      bubble.classList.remove('cart-link__bubble--visible');
    }
  }

  // Re-render the drawer contents from the server (grouped cart.ajax view) and
  // sync the footer totals + header bubble. Cache-bust so freshly-pushed markup
  // (qty, price, buttons) is never served stale.
  function refresh() {
    return fetch(root + 'cart?view=ajax&_=' + Date.now(), { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var freshItems = tmp.querySelector('.cart__items');
        var freshDiscounts = tmp.querySelector('.cart__discounts');

        var products = document.querySelector('[data-products]');
        if (products && freshItems) products.innerHTML = freshItems.outerHTML;

        var liveDiscounts = document.querySelector('[data-discounts]');
        if (liveDiscounts && freshDiscounts) {
          liveDiscounts.innerHTML = freshDiscounts.innerHTML;
          // Sync the hide-state too, so an empty "Rabat" label row never lingers
          // when there is no active cart-level discount.
          liveDiscounts.classList.toggle('hide', freshDiscounts.classList.contains('hide'));
        }

        var count = 0;
        if (freshItems) {
          count = parseInt(freshItems.getAttribute('data-count'), 10) || 0;

          var subtotal = freshItems.getAttribute('data-subtotal-display');
          var sub = document.querySelector('[data-subtotal]');
          if (sub && subtotal) sub.innerHTML = subtotal;

          // Mirror the total onto the checkout CTA so the customer commits with the number in view.
          var ctTotal = document.querySelector('[data-checkout-total]');
          if (ctTotal && subtotal) ctTotal.innerHTML = subtotal;

          var savingsEl = document.querySelector('[data-savings]');
          if (savingsEl) {
            // Contextual copy is built server-side in cart.ajax.liquid (never a
            // code name). Hide the box entirely when there's no cart-level saving.
            var savingsLabel = freshItems.getAttribute('data-savings-label');
            if (freshItems.hasAttribute('data-cart-savings') && savingsLabel) {
              savingsEl.innerHTML = '<div>' + savingsLabel + '</div>';
              savingsEl.classList.remove('hide');
            } else {
              savingsEl.classList.add('hide');
            }
          }
        }

        var drawer = document.getElementById('CartDrawer');
        if (drawer) drawer.classList.toggle('is-empty', count === 0);
        setBubble(count);

        var countEl = document.querySelector('[data-zcart-count]');
        if (countEl) countEl.textContent = count;
        updateUpsell();

        return count;
      });
  }

  /* ---- Discount router (single code, via /cart/update.js) ---------------- */
  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  // Apply ('CODE') or clear ('') the cart discount. Never throws — if the code
  // doesn't exist in Admin yet, Shopify simply won't apply it; we only log.
  function setDiscount(code) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  // Decide the one applicable cross-product code from the current cart, apply it,
  // then verify against /cart.js. Mutually-exclusive rules → single code only.
  function routeDiscounts() {
    return getCart().then(function (cart) {
      var handles = {};
      (cart.items || []).forEach(function (it) { handles[it.handle] = true; });
      var hasPro = !!handles['zen-pro'];
      var hasPulse = !!handles['zen-pulse'];
      var distinct = Object.keys(handles).length;

      var code = '';
      if (distinct >= 2) code = CODE_RUTINE;           // 2+ DISTINCT products, never 2-same
      if (hasPro && hasPulse && distinct === 2) {
        // EXACTLY Pro+Pulse: the 395 kr bundle story wins — kept deliberately
        // (Benji, 2026-07-06) even though 15% would save the customer more at
        // current prices. With a 3rd product in the cart the routine code
        // takes over (and is also the larger saving there), so the "15% på
        // hele ordren" promise holds everywhere it is made.
        code = CODE_PRO_PULSE;
      }

      return setDiscount(code).then(function () {
        return getCart().then(function (c2) {
          if (code === '' && c2.total_discounts !== 0) {
            console.warn('[ZenCart] clear ikke effektiv — total_discounts=' + c2.total_discounts + ' (skal validere /cart/update.js {discount:""}).');
          } else if (code !== '' && c2.total_discounts === 0) {
            console.warn('[ZenCart] code "' + code + '" gav ingen rabat — findes den (aktiv) i Admin?');
          }
          return c2;
        });
      });
    }).catch(function () { /* never break the cart flow */ });
  }

  // route -> re-render (used after every add/change/remove)
  function syncCart() { return routeDiscounts().then(function () { return refresh(); }); }
  // route -> re-render -> open (used by add-to-cart entry points)
  function syncCartAndOpen() {
    return routeDiscounts()
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function () { openDrawer(); });
  }

  /* ---- Cart normalizer: unitQty <-> pack/single composition ------------- */
  // In-flight /cart/update.js promises. Checkout waits on these so a customer
  // can't leave for checkout with a composition POST still on the wire.
  var inflight = [];
  function trackInflight(p) {
    inflight.push(p);
    var done = function () {
      var i = inflight.indexOf(p);
      if (i > -1) inflight.splice(i, 1);
    };
    p.then(done, done);
    return p;
  }

  // Compose a target unitQty from a product's real per-unit SKUs (each
  // {id, units}). For qty >= 2 we use ONLY the 2-stk + 3-stk packs, never the
  // single, so every unit lands on the 2-pak unit price (2->2-stk, 3->3-stk,
  // 4->2×2-stk, 5->3-stk+2-stk, 6->3×2-stk). Returns { variantId: quantity }
  // with EVERY known variant set (unused ones to 0) so update.js is absolute.
  function composeUnits(variants, unitQty) {
    var updates = {};
    variants.forEach(function (v) { updates[String(v.id)] = 0; });
    if (unitQty <= 0) return updates;

    var byUnits = {};
    variants.forEach(function (v) { byUnits[v.units] = String(v.id); });

    if (unitQty === 1 && byUnits[1]) {
      updates[byUnits[1]] = 1;
      return updates;
    }
    if (unitQty >= 2 && byUnits[2] && byUnits[3]) {
      var threes = (unitQty % 2 === 1) ? 1 : 0; // odd -> one 3-pak, rest 2-paks
      updates[byUnits[3]] = threes;
      updates[byUnits[2]] = (unitQty - threes * 3) / 2;
      return updates;
    }
    // Fallback (a needed pack is missing): greedy largest-first; reaches the
    // single only as a last resort so the total still sums exactly.
    var packs = variants.slice().sort(function (a, b) { return b.units - a.units; });
    var rem = unitQty;
    packs.forEach(function (v) {
      var q = Math.floor(rem / v.units);
      updates[String(v.id)] = q;
      rem -= q * v.units;
    });
    return updates;
  }

  function parseVariants(row) {
    try { return JSON.parse(row.getAttribute('data-variants') || '[]'); }
    catch (e) { return []; }
  }

  // RAW: only POST the composition to Shopify. No route, no re-render. Used both
  // by the normal path (below) and by flushPendingUnits() at checkout, where we
  // must not trigger extra refreshes.
  function setUnitQtyRaw(variants, unitQty) {
    if (!variants || !variants.length) return Promise.resolve();
    if (unitQty < 0) unitQty = 0;
    var updates = composeUnits(variants, unitQty);
    return trackInflight(fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }));
  }

  // Normal path: raw update, then route + re-render the drawer.
  function setUnitQty(variants, unitQty) {
    return setUnitQtyRaw(variants, unitQty).then(function () { return syncCart(); });
  }

  // Debounced per-handle so a burst of +/- clicks doesn't re-render mid-tap.
  // The count updates optimistically on each click; the Cart API + route + render
  // run once, ~350ms after the last click. pendingUnits holds the latest desired
  // unitQty per handle so checkout can flush anything still waiting on its timer.
  var unitTimers = {};
  var pendingUnits = {};
  function queueUnit(handle, variants, unitQty) {
    pendingUnits[handle] = { variants: variants, unitQty: unitQty };
    clearTimeout(unitTimers[handle]);
    unitTimers[handle] = setTimeout(function () {
      delete unitTimers[handle];
      var pend = pendingUnits[handle];
      delete pendingUnits[handle];
      if (pend) setUnitQty(pend.variants, pend.unitQty);
    }, 350);
  }

  // Fire any +/- still waiting on its debounce timer, then resolve only once
  // every in-flight /cart/update.js has landed. Uses the RAW writer (no per-item
  // refresh) — checkout routes + submits afterwards, so a re-render would be
  // wasted. No loop: raw never calls syncCart/queueUnit.
  function flushPendingUnits() {
    Object.keys(pendingUnits).forEach(function (handle) {
      clearTimeout(unitTimers[handle]);
      delete unitTimers[handle];
      var pend = pendingUnits[handle];
      delete pendingUnits[handle];
      if (pend) setUnitQtyRaw(pend.variants, pend.unitQty);
    });
    return Promise.all(inflight.slice());
  }

  // Catch-all add-to-cart: handle any /cart/add form that isn't already handled
  // by its own inline script (those preventDefault first).
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.classList.remove('loading');
        syncCartAndOpen();
      })
      .catch(function () {
        if (btn) btn.classList.remove('loading');
      });
  }, false);

  // Quantity +/- inside the drawer — steps unitQty for the whole product.
  // Capture phase + stopImmediatePropagation so Motion's own handler can't
  // double-fire on the injected markup.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-qty__adjust') : null;
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var row = btn.closest('.cart__item');
    var wrap = btn.closest('.js-qty__wrapper');
    var count = wrap && wrap.querySelector('.js-qty__count');
    if (!row || !count) return;

    var handle = row.getAttribute('data-handle');
    var variants = parseVariants(row);
    if (!handle || !variants.length) return;

    var current = parseInt(count.textContent, 10) || 0;
    var isPlus = btn.classList.contains('js-qty__adjust--plus');
    var next = isPlus ? current + 1 : current - 1;
    if (next < 0) next = 0;

    count.textContent = next; // optimistic: instant, never hops back (stable line)
    queueUnit(handle, variants, next);
  }, true);

  // Trash removes the whole product — every underlying variant to 0.
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('.js-cart-remove') : null;
    if (!rm || !rm.closest('#CartDrawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var row = rm.closest('.cart__item');
    if (!row) return;
    var variants = parseVariants(row);
    if (variants.length) setUnitQty(variants, 0);
  }, true);

  // Checkout: (1) flush any pending +/- so the cart holds the customer's latest
  // quantity, (2) let the router apply the correct code, then (3) submit. Without
  // the flush, a fast "+ then checkout" could leave for checkout with old qty.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.zcart__checkout') : null;
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    flushPendingUnits()
      .then(function () { return routeDiscounts(); })
      .then(function () {
        var form = btn.form || document.getElementById('CartDrawerForm');
        if (form && form.requestSubmit) form.requestSubmit(btn);
        else if (form) form.submit();
        else window.location.href = root + 'checkout';
      })
      .catch(function () { window.location.href = root + 'checkout'; });
  }, true);

  // Safety net: make sure closing the drawer never leaves the visitor locked.
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.js-drawer-close'))) return;
    var d = document.getElementById('CartDrawer');
    if (d) setTimeout(function () { d.classList.remove('is-active'); }, 60);
  });

  // In-cart upsell: 395 bundle nudge (Zen Pro -> Zen Pulse) + cross-sell for the
  // "2 produkter = 15%" routine offer. Shows up to 2 relevant cards.
  function updateUpsell() {
    var wrap = document.querySelector('[data-zcart-upsell]');
    if (!wrap) return;
    getCart()
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { inCart[it.handle] = true; });
        var cards = wrap.querySelectorAll('.zcart__up-card');
        var titleEl = wrap.querySelector('[data-zcart-upsell-title]');
        var hasZenPro = !!inCart['zen-pro'];
        var shown = 0, bundleShown = false;

        cards.forEach(function (c) { c.hidden = true; c.classList.remove('is-bundle'); });

        // 1) Bundle nudge: Zen Pulse at 395 — only when the cart holds Zen Pro
        // and nothing else. With other products in the cart the routine code
        // (15%) wins in the router, so the fixed "395 kr" claim would be wrong;
        // those carts get the generic cross-sell instead.
        if (hasZenPro && !inCart['zen-pulse'] && Object.keys(inCart).length === 1) {
          var pulse = wrap.querySelector('.zcart__up-card[data-up-handle="zen-pulse"]');
          if (pulse) { pulse.hidden = false; pulse.classList.add('is-bundle'); shown++; bundleShown = true; }
        }

        // 2) Cross-sell: fill up to 2 cards with products not already in the cart.
        cards.forEach(function (c) {
          if (shown >= 2 || !c.hidden) return;
          var h = c.getAttribute('data-up-handle');
          if (inCart[h]) return;
          if (h === 'zen-pulse' && bundleShown) return;
          c.hidden = false; shown++;
        });

        if (titleEl) {
          if (bundleShown) {
            // Read the bundle price from the drawer card (computed server-side
            // as price minus 200 kr) so there is a single source for the number.
            var bpEl = wrap.querySelector('.zcart__up-card[data-up-handle="zen-pulse"] .zcart__up-price-bundle strong');
            var bp = bpEl && bpEl.textContent ? bpEl.textContent.trim() : '395 kr';
            titleEl.textContent = 'Tilføj din massagepistol for kun ' + bp;
          }
          // "15% på begge" må kun loves når det faktisk holder. Ligger Zen
          // Pulse alene i kurven, er det mest oplagte naeste klik Zen Pro —
          // og praecis DET par rammer ZN-PP200 (200 kr = 8,7%), ikke de 15%.
          // Alle andre 1-vare-kurve giver 15% uanset hvad der tilfoejes.
          // Rettet 2026-08-15; bundle-beslutningen selv er uroert.
          // Object.keys(inCart).length, ikke cart.item_count: item_count er
          // summen af quantity, saa en kurv med fx 4 stk af ÉT produkt (som
          // composeUnits() lægger ind som 2x 2-stk-pakken) talte som 2 og
          // mistede loeftet. Samme taellemaade som bundle-checket ovenfor.
          // Rettet i /kontrol 2026-08-15.
          else if (Object.keys(inCart).length === 1 && !inCart['zen-pulse']) titleEl.textContent = 'Tilføj ét til og få 15% på begge';
          else titleEl.textContent = 'Færdiggør din rutine';
        }

        wrap.hidden = (shown === 0 || cart.item_count === 0);
      })
      .catch(function () {});
  }

  // "Tilføj" on an upsell card -> add the variant, then route + refresh the open drawer.
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-up-add]') : null;
    if (!add) return;
    e.preventDefault();
    var vid = add.getAttribute('data-up-add');
    if (!vid) return;
    add.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { add.classList.remove('loading'); return syncCart(); })
      .catch(function () { add.classList.remove('loading'); });
  });

  window.ZenCart = {
    refresh: refresh,
    open: openDrawer,
    refreshAndOpen: syncCartAndOpen,
    route: routeDiscounts,
    setUnitQty: setUnitQty
  };

  // On load: carts can arrive without an add-event (cart permalinks from
  // find-solution's no-JS fallback, shared links, back-navigation), so route
  // once when the cart holds items — then the drawer, totals and upsell all
  // reflect the right code before the customer can reach checkout.
  function initCart() {
    getCart()
      .then(function (cart) {
        if (cart.item_count > 0) {
          return routeDiscounts().then(function () { return refresh(); });
        }
        updateUpsell();
      })
      .catch(function () { updateUpsell(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }
})();
